<template>
  <v-container class="neat-container">
    <hr class="separator" />
    <img class="mb-3" src="../../assets/car.png" alt="Car Picture" />
    <h5 class="mb-0">{{ type }}</h5>
    <h5 class="mb-0">{{ vin }} <CopyButton :text="vin" size="medium" /></h5>
    <h5 class="mb-0">{{ $t('registrationPage.carInfo.registered') }} {{ regDate }} <CopyButton :text="regDate" size="medium" /></h5>
    <h5 class="mb-0">{{ $t('registrationPage.carInfo.status') }} {{ statusString }}</h5>
    <router-link to="/partstosave">
      <v-btn class="mt-2 mb-3" color="#033e8c" height="45px" dark block>Inspect</v-btn>
    </router-link>
  </v-container>
</template>

<script>
import CopyButton from "@/components/common/CopyButton.vue"

export default {
  name: "CardStatusCard",
  props: {
    type: String,
    vin: String,
    regDate: String,
    status: String,
  },
  computed: {
    statusString() {
      const index = parseInt(this.status)
      console.log("!@#$%", `registrationPage.carStatus[${index}]`)
      return this.$t(`registrationPage.carStatus[${index}]`)
    }
  },
  components: {
    CopyButton
  }
}
</script>

<style scoped>
h5 {
  font-size: 1.125rem;
  text-align: left;
  padding-left: 0.625rem;
  padding-right: 0.625rem;
}
</style>